/** True when mounted from Shopify / commerce embed (SuperSplatMountHost commerceMode). */
export function isVolugraphCommerceMode(): boolean {
    const w = window as unknown as {
        __VOLUGRAPH_SUPER_SPLAT_CONFIG__?: { volugraphCommerceMode?: boolean };
    };
    return w.__VOLUGRAPH_SUPER_SPLAT_CONFIG__?.volugraphCommerceMode === true;
}
